import { render, staticRenderFns } from "./StTeaserService.vue?vue&type=template&id=1a617f22"
import script from "./StTeaserService.vue?vue&type=script&lang=ts"
export * from "./StTeaserService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports